//src/components/common/PrivacyPolicy/CompanyTermsAndPolicy/TermsAndPolicyFooter.jsx

import React from 'react'
import { FaFacebookSquare } from 'react-icons/fa'
import { FaLinkedin, FaSquareInstagram, FaTwitter } from 'react-icons/fa6'
import logo from "../../../../assets/images/myassessment.ai_logo.png"
import { Link } from 'react-router-dom'

const TermsAndPolicyFooter = () => {
  return (
    <div className="relative w-full mt-10 overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-60 h-60 bg-purple-400 opacity-20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-60 h-60 bg-blue-400 opacity-20 blur-3xl rounded-full"></div>

      {/* FOOTER */}
      <div className="relative w-full 
      bg-white/70 backdrop-blur-lg border-t border-white/30 
      shadow-sm py-4 px-6 md:px-10">

        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 items-center gap-4">

          {/* LEFT - LOGO */}
          <div className="flex justify-center md:justify-start">
            <Link to="/">
              <img
                src={logo}
                alt="myassessment.ai"
                className="w-[110px] md:w-[130px]"
              />
            </Link>
          </div>

          {/* CENTER - COPYRIGHT */}
          <div className="text-center text-xs text-gray-500">
            © TakshkAI HR Solutions Pvt Ltd. All rights reserved
          </div>

        <div className="flex justify-center md:justify-end items-center gap-4">

  {/* Icons */}
  <div className="flex items-center gap-3">

    {/* Privacy Policy */}
  <Link
    to="/termsAndPolicy"
    className="text-sm text-gray-700 font-medium leading-none flex items-center hover:text-purple-600 transition"
  >
    Privacy Policy
  </Link>
    <div className="p-1.5 rounded-full bg-white shadow hover:scale-110 hover:bg-blue-100 transition cursor-pointer">
      <FaTwitter className="w-4 h-4 text-gray-600" />
    </div>

    <div className="p-1.5 rounded-full bg-white shadow hover:scale-110 hover:bg-blue-100 transition cursor-pointer">
      <FaLinkedin className="w-4 h-4 text-gray-600" />
    </div>

    <div className="p-1.5 rounded-full bg-white shadow hover:scale-110 hover:bg-pink-100 transition cursor-pointer">
      <FaSquareInstagram className="w-4 h-4 text-gray-600" />
    </div>

    <div className="p-1.5 rounded-full bg-white shadow hover:scale-110 hover:bg-blue-100 transition cursor-pointer">
      <FaFacebookSquare className="w-4 h-4 text-gray-600" />
    </div>
  </div>

  

</div>

        </div>

      </div>

    </div>
  )
}

export default TermsAndPolicyFooter;